import { Components } from '@mui/material/styles/components';
import { ControllerProgressColor } from '../../palette';

export const CircularProgressComponent: Components = {
  MuiCircularProgress: {
    styleOverrides: {
      colorPrimary: {
        color: String(ControllerProgressColor.Primary1),
      },
      colorSecondary: {
        color: String(ControllerProgressColor.Secondary1),
      },
    },
  },
};
